import styled, { css } from 'styled-components';

import {
  zIndexElevatedLayer5,
  mediaTopBarVisible,
} from '@xing-com/layout-tokens';
import { Logo } from '@xing-com/platform-layout-logo';
import {
  xdlColorBackground,
  scale010,
  scale170,
  xdlColorBorderSoft,
  scale210,
  spaceL,
  spaceXXL,
  space3XL,
} from '@xing-com/tokens';

type StyledHeaderPlaceboProps = {
  $showOnSmallerScreens: boolean;
};

export const StyledHeaderPlacebo = styled.div<StyledHeaderPlaceboProps>`
  height: ${scale210};

  @media ${mediaTopBarVisible} {
    height: ${scale170};
  }

  @media ${mediaTopBarVisible} {
    ${({ $showOnSmallerScreens }) =>
      $showOnSmallerScreens
        ? css``
        : css`
            display: none;
          `}
  }

  @media print {
    display: none;
  }
`;

export const StyledHeaderWrapper = styled.header`
  background-color: ${xdlColorBackground};
  border-bottom: ${scale010} solid ${xdlColorBorderSoft};
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: calc(${zIndexElevatedLayer5} - 50);

  @media ${mediaTopBarVisible} {
    height: calc(${scale170});
  }
`;

export const StyledHeader = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex: 1 0 auto;
  flex-wrap: nowrap;

  height: ${scale210};
  @media ${mediaTopBarVisible} {
    height: ${scale170};
  }
`;

export const StyledLogoWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 100%;
`;

export const StyledLogoDesktop = styled(Logo)`
  display: none;
  margin-right: ${spaceXXL};

  @media (min-width: 1268px) {
    display: flex;
    align-items: center;
  }

  @media (min-width: 1356px) {
    margin-right: ${space3XL};
  }
`;

export const StyledLogoMobile = styled(Logo)`
  display: block;
  margin-right: ${spaceL};
  @media (min-width: 1268px) {
    display: none;
  }
`;
